export const buildChecklistEditFormState = (checklist) => {
  return {
    name: String(checklist?.name ?? '').trim(),
    description: String(checklist?.description ?? ''),
  }
}

export const resolveChecklistNotesPayload = (notes) => {
  const normalizedNotes = String(notes ?? '')

  return normalizedNotes.trim().length > 0 ? normalizedNotes : null
}
